const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  },
  centred: {
    width: '100%',
    //maxWidth: '1320px',
    alignSelf:'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  flex: {
    flex: 1
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.primary.light,
    color:'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover':{
      backgroundColor: theme.palette.primary.main,
    }
  },
  burger: {
    padding: 10,
    background: theme.palette.primary.main,
    borderRadius: 0,
    width: '63px',
    height: '63px',
    marginLeft: '-24px'
  },
  navBar: {
    backgroundColor: 'white'
  },
  headerLogo: {
    marginLeft: '20px',
     flex: 1,
     paddingTop: '7px',
     '& img':{
       float:'left',
     }
  },
  betaLogo:{
    color: '#005795',
    fontSize: '1.2rem',
    float: 'left',
    paddingTop: '9px',
    paddingLeft: '17px',
    '@media (min-width: 480px) and (max-width: 696px)': {
        color: '#005795',
        fontSize: '1.2rem',
        float: 'left',
        paddingTop: '0',
        paddingLeft: '53px'
    }
  },
  loggedInInitials: {
    textTransform: 'none'
  }
})

export default styles
